import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addVisit } from 'slice/visitSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Add = () => {
    const [formData, setFormData] = useState({
        name: '',
        rating: 5,
        counting: '',
        status: 1
    });
    const [images, setImages] = useState([]);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.visit);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setImages(e.target.files);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (images.length === 0) {
            toast.error('Please select at least one image');
            return;
        }

        const data = new FormData();
        Object.entries(formData).forEach(([key, val]) => data.append(key, val));
        for (let i = 0; i < images.length; i++) {
            data.append('images', images[i]);
        }

        dispatch(addVisit(data));
        toast.success('Place added successfully!');
        setTimeout(() => navigate('/khajuraho/visits'), 1500);
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Add Place to Visit</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="name" className="adminlables">Place Name</label>
                        <input type="text" id="name" name="name" value={formData.name} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="rating" className="adminlables">Rating (1-5)</label>
                        <input type="number" id="rating" name="rating" min="1" max="5" value={formData.rating} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-6 mt-4">
                        <label htmlFor="images" className="adminlables">Upload Images (Multiple)</label>
                        <input type="file" id="images" className="form-control filebg" onChange={handleFileChange} multiple required />
                    </div>
                    <div className="col-sm-6 mt-4">
                        <label htmlFor="status" className="adminlables">Status</label>
                        <select id="status" name="status" value={formData.status} className="form-control" onChange={handleChange}>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </select>
                    </div>
                </div>
                <div className="mt-5 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Adding...' : 'Add Place'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Add;
